import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { SeatedTourWidget } from './SeatedTourWidget';
export function Tour() {
  return <section id="tour" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-94" data-mp="1lt351mfaeuog">
      <SectionHeader number="01" title="Live Dates" data-id="element-95" data-mp="1gu8h662gqfxh" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full max-w-[1000px] mx-auto" data-id="element-96" data-mp="1gurx5h8jyu8v">
        <SeatedTourWidget data-id="element-97" data-mp="y3h8z7u7ovko" />
      </motion.div>
    </section>;
}